export default {
  namespaced: true,
  state: {
    loading: true,
    flayersList: [],
    flayersShow: {},
  },

  getters: {
    isLoading(state) {
      return state.loading;
    },
    getFlayersList(state) {
      return state.flayersList;
    },
    getFlayersShow(state) {
      return state.flayersShow;
    },
  },

  mutations: {
    setLoading(state, isLoading) {
      state.loading = isLoading;
    },
    setFlayersList(state, data) {
      state.flayersList = data;
    },
    setFlayersShow(state, data) {
      state.flayersShow = data;
    },
  },

  actions: {
    /**
     * Fetch array of Flayers
     *
     * @param state
     * @param commit
     * @param data
     * @returns {Promise<[]>}
     */
    async fetchList({ state, commit, rootGetters }) {
      commit("setLoading", true);
      try {
        let response = await this._vm.$http({
          url: `/api/v1/client/flayers`,
          headers: {
            "content-type": "application/json",
            Authorization: rootGetters.authToken,
          },
        });
        commit("setFlayersList", response.data);
        commit("setLoading", false);
      } catch (error) {
        commit("setLoading", false);
        throw error;
      }
      return state.flayersList;
    },

    /**
     * Reset state to initial values
     *
     * @param commit
     */
    reset({ commit }) {
      commit("setFlayersList", []);
      commit("setFlayersShow", {});
      commit("setLoading", true);
    },
  },
};
